// App.jsx
// Renders the guided housing advocacy experience and wires up analytics tracking.
import LandingRouter from './routes/LandingRouter';
import usePageViews from './hooks/usePageViews';
import ScrollToTop from './components/ScrollToTop';

/**
 * App
 * Bootstraps analytics and returns the landing router.
 */
export default function App() {
  usePageViews();
  return (
    <>
      <ScrollToTop />
      <LandingRouter />
    </>
  );
}
